export const CART_PENDING = 'CART_PENDING'
export const CHECKOUT_PENDING = 'CHECKOUT_PENDING'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
